module.exports = __webpack_public_path__ + "static/media/trophy.aed94704.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/trophy.png
// module id = 3314
// module chunks = 0